import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
Vue.config.productionTip = false
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

// Windi CSS 会被 webpack 插件自动注入，不需要手动导入

import './style/common.css'
import './assets/styles/reset.css'
//导航守卫
import './common/fuards/index'
import 'windi.css'

// import VueLazyload from 'vue-lazyload'
// Vue.use(VueLazyload, {
//   //完全显示的时候加载
//   preLoad: 1,
//   //失败时显示的图片
//   error: require('./assets/images/error.png'),
//   //加载时显示的GIF图
//   loading: require('./assets/images/loading.gif'),
//   //尝试加载几次
//   attempt: 1
// });
import 'animate.css'
import VideoPlayer from 'vue-video-player'
// require('video.js/dist/video-js.css')  //按官网引会找不到然后报错，换成下面那个
require('vue-video-player/node_modules/video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

import Message from '@/components/MassagesBox/install'
Vue.use(Message)

import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
VueViewer.setDefaults({
  title: false,
  toolbar: false,
  navbar: false,
});
Vue.use(VueViewer);
import Header from '@/components/Header'
import NewHeader from '@/components/IndexHeader'

Vue.component('other-header', Header)
Vue.component('index-header', NewHeader)

import { Tooltip } from 'element-ui';
Vue.component(Tooltip.name, Tooltip);


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
